import {
  RuleField,
  RuleOperator,
  ConditionJoin,
  RuleConditionValue,
} from 'features/RuleBuilder'

export type AutoInviteSetting = 'DISABLED' | 'WITH_EMAIL' | 'WITHOUT_EMAIL'
export type AutoInviteScope = 'ALL_NEW' | 'MATCHING'

export interface AutoInviteRule {
  id: string
  scope: AutoInviteScope
  field?: RuleField | null
  operator?: RuleOperator | null
  value?: RuleConditionValue | null
  secondaryField?: RuleField | null
  secondaryOperator?: RuleOperator | null
  secondaryValue?: RuleConditionValue | null
  conditionJoin?: ConditionJoin | null
  tertiaryField?: RuleField | null
  tertiaryOperator?: RuleOperator | null
  tertiaryValue?: RuleConditionValue | null
  tertiaryConditionJoin?: ConditionJoin | null
}

export const DEFAULT_MATCHING_CONDITIONS: Pick<
  AutoInviteRule,
  | 'field'
  | 'operator'
  | 'value'
  | 'secondaryField'
  | 'secondaryOperator'
  | 'secondaryValue'
  | 'conditionJoin'
  | 'tertiaryField'
  | 'tertiaryOperator'
  | 'tertiaryValue'
  | 'tertiaryConditionJoin'
> = {
  field: 'worksite_name',
  operator: 'equals',
  value: '',
  secondaryField: null,
  secondaryOperator: null,
  secondaryValue: null,
  conditionJoin: 'and',
  tertiaryField: null,
  tertiaryOperator: null,
  tertiaryValue: null,
  tertiaryConditionJoin: 'and',
}
